import React from 'react';
import PropTypes from 'prop-types';
import ChevronIcon from './chevron_icon';

const RoundPickerTrigger = ({ label, date, isOpen, showPlayAt = false, onClick }) => (
  <div className="lbv2__selected-round">
    <button className="lbv2__open-selector-btn" onClick={onClick}>
      <div className="lbv2__open-selector-text">
        <div className="open-selector-btn-text-name">{label}</div>
        {!showPlayAt && date && <div className="open-selector-btn-text-date">({date})</div>}
      </div>
      <ChevronIcon isOpen={isOpen} />
    </button>
    {showPlayAt && date && (
      <div className="lbv2__round-btn-text-date">{date}</div>
    )}
  </div>
);

RoundPickerTrigger.propTypes = {
  label: PropTypes.string.isRequired,
  date: PropTypes.string,
  isOpen: PropTypes.bool,
  showPlayAt: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default RoundPickerTrigger;
